var React = require('react');

function InfoIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M7.381 4.712a.787.787 0 00.537.192.737.737 0 00.523-.192.67.67 0 00.22-.51.629.629 0 00-.22-.495.71.71 0 00-.523-.207.756.756 0 00-.537.207.648.648 0 00-.206.495c0 .202.069.372.206.51z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M7.546 10.77H6.5v.73h3.03v-.73h-.978V6.09H6.514v.73h1.032v3.951z","key":1}),React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M16 8A8 8 0 110 8a8 8 0 0116 0zm-.696 0A7.304 7.304 0 11.696 8a7.304 7.304 0 0114.608 0z","clipRule":"evenodd","key":2})]);
}

InfoIcon.defaultProps = {"fill":"none","viewBox":"0 0 16 16"};

module.exports = InfoIcon;

InfoIcon.default = InfoIcon;
